// Slug helper. Mirrors backend make_slug(): lowercase, strip accents, alphanumerics only.
export function makeSlug(text) {
  if (!text) return "";
  const stripped = text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  return stripped.toLowerCase().replace(/[^a-z0-9]+/g, "");
}
